import { GenericMapping, GenericMappingType } from '../../search/types'

export const ASANA_GENERIC_MAPPINGS: GenericMapping[] = [
  {
    key: 'assignee',
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'The user who is assigned to the task',
  },
  {
    key: 'createdBy',
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'The user who created the task',
  },
  {
    key: 'completedAt',
    type: GenericMappingType.DATE,
    name: 'Completion date',
    description: 'The date and time the task was completed',
  },
  {
    key: 'completedBy',
    type: GenericMappingType.KEYWORD,
    name: 'Completed By',
    description: 'The user who completed the task',
  },
  {
    key: 'startedAt',
    type: GenericMappingType.DATE,
    name: 'Start date',
    description: 'The date and time the task was started',
  },
  {
    key: 'dueAt',
    type: GenericMappingType.DATE,
    name: 'Due date',
    description: 'The date and time the task is due',
  },
  {
    key: 'approvalStatus',
    type: GenericMappingType.KEYWORD,
    name: 'Approval status',
    description: 'The approval status of the task',
    enum: ['pending', 'approved', 'rejected', 'changes_requested'],
  },
  {
    key: 'tags',
    type: GenericMappingType.KEYWORD,
    name: 'Tags',
    description: 'The tags associated with the task',
  },
  {
    key: 'projects',
    type: GenericMappingType.KEYWORD,
    name: 'Projects',
    description: 'The projects the task is associated with',
  },
  {
    key: 'teams',
    type: GenericMappingType.KEYWORD,
    name: 'Teams',
    description: 'The teams the task is associated with',
  },
  {
    key: 'sections',
    type: GenericMappingType.KEYWORD,
    name: 'Sections',
    description:
      'The sections the task is associated with including the project',
  },
] as const
